import { IAccountState, IGetAccountArgs, IGetAccountPayload } from '../types';
import { GET_ACCOUNTS } from '../constants';
import accountServices from '../accountServices';
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'app/utils/constant';

export const getAccounts = createAsyncThunk<
  IGetAccountPayload,
  IGetAccountArgs,
  ThunkAPIConfig
>(GET_ACCOUNTS, async (args, { rejectWithValue }) => {
  try {
    const params = {
      ...args,
      page: args?.page || 1,
      limit: args?.limit || PAGE_SIZE,
      status: args.status ? args.status : undefined,
      name: args.name ? args.name : undefined
    };

    const { data } = await accountServices.getAccountList(params);
    const { result, metaData } = data.data;

    return {
      data: result,
      pagination: metaData
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAccountsBuilder = (
  builder: ActionReducerMapBuilder<IAccountState>
) => {
  const { pending, fulfilled, rejected } = getAccounts;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data, pagination } = action.payload;
      draftState.loading = false;
      draftState.accountData = data;
      draftState.pagination = pagination;
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
